import { withPrefix } from 'gatsby';

import { isPlainObject, PlainObject } from '../helpers/helpers';

export type BuildOnlyBlocks = Record<string, Record<string, PlainObject>>;

const BUILD_BLOCKS_PATH =
  '/page-data/_live-preview/build-blocks/page-data.json';

let pendingBlocks: Promise<BuildOnlyBlocks> | undefined;

const toBlocksByUid = (nodes: unknown): Record<string, PlainObject> =>
  Array.isArray(nodes)
    ? Object.fromEntries(
        nodes
          .filter(
            (node): node is PlainObject =>
              isPlainObject(node) && typeof node.uid === 'string'
          )
          .map((node) => [node.uid as string, node])
      )
    : {};

const fetchBuildOnlyBlocks = async (): Promise<BuildOnlyBlocks> => {
  try {
    const response = await fetch(withPrefix(BUILD_BLOCKS_PATH));

    if (!response.ok) {
      console.warn(
        `[live-preview] build-only block data is missing (${response.status}) - a block added to a page since the last build cannot borrow it`
      );

      return {};
    }

    const { result } = await response.json();
    const data = result?.data;

    if (!isPlainObject(data)) return {};

    return Object.fromEntries(
      Object.entries(data).map(([blockType, value]) => [
        blockType,
        toBlocksByUid(isPlainObject(value) ? value.nodes : undefined),
      ])
    );
  } catch (error) {
    console.warn('[live-preview] could not load build-only block data:', error);

    return {};
  }
};

export const loadBuildOnlyBlocks = (): Promise<BuildOnlyBlocks> => {
  pendingBlocks ??= fetchBuildOnlyBlocks();

  return pendingBlocks;
};
